import { useMutation } from '@apollo/client';
import { toast, useActivityTracker, useProduct } from '@nile/components';
import {
  AccountClient,
  CREATE_SERVICE_ITEM,
  CREATE_SERVICE_ITEM_FOR_IT
} from '@nile/graphql';
import { CATALOG_INPUT_FIELDS } from '@nile/banyan/src/Pages/Constants/serviceCatalog';
import React, { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import CatalogSheet from './CatalogSheet';
import { removePropertiesForItProduct } from '@nile/itsm';

function NewServiceCatalog({
  history,
  onBack,
  onServiceItemCreation,
  removePadding = false,
  fullWidth
}) {
  const back = useCallback(() => {
    history.push('/onboard/serviceCatalog');
  }, []);
  const currentProduct = useProduct();
  const isMSPProduct = useProduct('MSP');

  const [createServiceItemWithInterceptor] = useMutation(
    isMSPProduct ? CREATE_SERVICE_ITEM : CREATE_SERVICE_ITEM_FOR_IT,
    {
      client: AccountClient,
      onCompleted({ createServiceItem }) {
        if (createServiceItem) {
          toast('success', 'Service item added successfully');
          useActivityTracker({
            event: 'Settings - Service item added successfully'
          });
          if (onServiceItemCreation) {
            onServiceItemCreation(createServiceItem);
            return;
          }
          back();
        }
      }
    }
  );
  async function createServiceItem(variables) {
    try {
      const payload = variables?.variables?.item || {};
      const updatedPayload = removePropertiesForItProduct(
        payload,
        'createServiceItem',
        currentProduct
      );
      const modifiedUpdatedPayload = {
        variables: {
          item: { ...updatedPayload }
        }
      };
      return await createServiceItemWithInterceptor(modifiedUpdatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  const actions = {
    primaryAction: createServiceItem,
    back: onBack ?? back
  };

  return (
    <CatalogSheet
      actions={actions}
      inputFields={CATALOG_INPUT_FIELDS}
      removePadding={removePadding}
      fullWidth={fullWidth}
    />
  );
}

export default withRouter(NewServiceCatalog);
